import styled from 'styled-components';

export const InfoTooltipWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const InfoTooltipIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  border: 1.5px solid ${(props) => props.theme.secondaryColor};
  background: transparent;
  color: ${(props) => props.theme.secondaryColor};
  font-size: 0.6rem;
  font-weight: 700;
  font-style: italic;
  font-family: Georgia, serif;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition:
    background-color 0.15s,
    color 0.15s;
  flex-shrink: 0;

  &:hover,
  &:focus-visible {
    background-color: ${(props) => props.theme.secondaryColor};
    color: white;
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px ${(props) => props.theme.focusShadow};
  }
`;

export const InfoTooltipBubble = styled.div`
  position: absolute;
  bottom: calc(100% + 0.6rem);
  left: 50%;
  transform: translateX(calc(-50% + ${(props) => props.$shift || '0px'}));
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.6rem 0.75rem;
  border-radius: ${(props) => props.theme.borderRadius};
  width: 13rem;
  font-size: ${(props) => props.theme.fontSizeSm};
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  z-index: 1000;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  pointer-events: ${(props) => (props.$show ? 'auto' : 'none')};
  transition: opacity 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: calc(50% - ${(props) => props.$shift || '0px'});
    transform: translateX(-50%);
    border: 0.4rem solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    transform: translateX(-90%);

    &::after {
      left: 90%;
      transform: translateX(-50%);
    }
  }
`;
